import { CsvDelimiterSpec, CsvDescription, CsvWriteDescription } from "./types";

export const defaultDescription = {
	delimiter: '\t',
	quote: '',
	encoding: 'utf-8',
	decimalSeparator: '.',
	header: false,
	nullValue: ''
} as CsvDescription;

export const defaultWriteDescription = {
	...defaultDescription,
	delimiterReplacement: ' ',
	quoteReplacement: '',
	crReplacement: '',
	lfReplacement: ' '
} as CsvDescription;

export const commonDelimiters: CsvDelimiterSpec[] = [
	{ char: ',', description: 'Comma' },
	{ char: ';', description: 'Semicolon' },
	{ char: '\t', description: 'Tab' },
	{ char: ' ', description: 'Space' },
	{ char: '|', description: 'Pipe' },
];
